<template>
  <footer>
    <div class="wrap">
      <p>主办单位：中宁工业园区管理委员会 <span>|</span> 联系电话：0955 - 5682477</p>
      <p>单位地址：宁夏回族自治区中卫市中宁县宏岩矿业旁</p>
      <p><a href="https://beian.miit.gov.cn" target="_blank">宁ICP备 2023001090 号</a></p>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'BasicFooter',
}
</script>

<style scoped>
.wrap{
  margin: 0 auto;
  width: 1200px;
}
footer {
	width: 100%;
	min-width: 1200px;
	background-color: #015cb9;
	padding: 18px 0 23px;
}

footer p {
	color: #fff;
	padding-top: 9px;
}

footer a {
	color: #fff !important;
}
</style>
